import { Component, OnInit, Optional, Inject, PLATFORM_ID } from '@angular/core';
import { RESPONSE, REQUEST } from '@nguniversal/express-engine/tokens';
import { Request, Response } from 'express';
import { Product } from './shared/product.model';
import { DataService } from './services/data.service';
import { CartService } from './services/cart.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Common } from '../app/model/common.model';
import { ContactService } from './services/contact.service';
import { LoadingService } from './services/loading.service';
import { HostListener } from '@angular/core';
import { SEOService } from './services/seo.service';
import { environment } from '../environments/environment';
// import 'rxjs/add/operator/filter';
import { Subscription } from 'rxjs';

import { filter } from 'rxjs/operators';
//import * as $ from 'jquery';
// import { concatAll } from 'rxjs/operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

})
export class AppComponent implements OnInit {
  contactDtl: any;
  HTTPActivity: boolean;
  date: Date = new Date();
  settings = {
    bigBanner: true,
    timePicker: false,
    format: 'MM-dd-yyyy',
    defaultOpen: true
  }
  
  products: Product[]
  Secondcontact: any;
  mainFilter: any

  currentSorting: string
  isaccesswithlogin: any='1';
  sessionId: string;
title:any;
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.router.url != '/product') {      
      
      var getpageno = Common.getWithExpiry("pageNo");      
      this.cartService.setbackflag('1');
      if(getpageno!=undefined && getpageno!=null){
      this.cartService.setpageno(getpageno);
      
      }
      var getitemname = Common.getWithExpiry("itemname");      
      if(getitemname!=undefined && getitemname!=null){
      this.cartService.setitemname(getitemname);
      }
      var pagesize = Common.getWithExpiry("pagesize");      
      if(pagesize!=undefined && pagesize!=null){
      this.cartService.setpagesizeno(pagesize);
      }
      var stype = Common.getWithExpiry("stype");      
      if(stype!=undefined && stype!=null){
      this.cartService.setstype(stype);
      }
      var Position = Common.getWithExpiry("Position");      
      if(Position!=undefined && Position!=null){
      this.cartService.setPosition(Position);
      }
    }
  }

  // @ViewChild('filtersComponent')
  // filtersComponent: FiltersComponent;

  // @ViewChild('searchComponent')
  // searchComponent: SearchBarComponent;

  // sortFilters: any[] = [
  //   { name: 'Name (A to Z)', value: 'name' },
  //   { name: 'Price (low to high)', value: 'priceAsc' },
  //   { name: 'Price (high to low)', value: 'priceDes' }
  // ]

  // customFilters: any[] = [
  //   { name: 'All', value: 'all', checked: true },
  //   { name: 'Available', value: 'available', checked: false },
  //   { name: 'Not Available', value: 'unavailable', checked: false },
  //   { name: 'Bestseller', value: 'bestseller', checked: false }
  // ]

  // priceFilters: any[] = [
  //   { name: 'All', value: 'all', checked: true },
  //   { name: 'Price > 30.000', value: 'more_30000', checked: false },
  //   { name: 'Price < 10.000', value: 'less_10000', checked: false }
  // ]

  originalData: any = []
  route: string;
  
  public loading = false;
  subscription: Subscription;
  url: string;
  isLoggedIn:boolean=false;
  Allconfigurationlist:any=[];
  private _routerSub = Subscription.EMPTY;
  constructor(@Optional() @Inject(REQUEST) private request: Request,
  @Optional() @Inject(RESPONSE) private response: Response,
  @Inject(PLATFORM_ID) private platformId: any,private seoService: SEOService,private contactService: ContactService, private loadingService: LoadingService, private dataService: DataService, private cartService: CartService, private router: Router, location: Location) {
    
    //this.dataService.Getallconfigurations();
    //this.dataService.GetProductPageConfigurationsnew();
    //this.GetFooterPageConfigurations();
    // this.router.events.subscribe((ev) => {
    //   //this.cartService.setpageno(undefined);
    //   if (ev instanceof NavigationEnd) {
    //     this.url = this.router.url;
    //   }
    // });
    this._routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationStart))    
      .subscribe((value) => {             
       
      });
    this._routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))    
      .subscribe((value) => {        
        this.getisaccesswithlogin(); 
        if (Common.getWithExpiry("CustID") != "" && Common.getWithExpiry("CustID") != null) {
          this.isLoggedIn = true;
        }
        
        //this.cartService.setpageno(undefined);
        if(this.router.url.indexOf('/productdetail/')==-1 && this.router.url.indexOf('/products/')==-1 && this.router.url.indexOf('/productlist/')==-1 && this.router.url.indexOf('/category/')==-1 && this.router.url.indexOf('/search/')==-1)
        {
          this.cartService.setpageno(undefined);
        }
        else if (this.router.url.indexOf('/categories/')==-1 || this.router.url.indexOf('/category/')==-1 || this.router.url.indexOf('/products/')==-1 || this.router.url.indexOf('/product/')==-1){
          
        } 
        else{
          this.seoService.createLinkForCanonicalURL();
        }      
        this.url = this.router.url;
        
        if(this.router.url.indexOf('/search/')!=-1){
          this.seoService.setnoindextag();
        }
        if(this.isLoggedIn){
          this.isaccesswithlogin='1';
        }
        // || this.router.url=='/home'
        if(this.router.url=='/sitemap'  || this.router.url.indexOf('/contact')>-1 || this.router.url=='/viewcart' || this.router.url=='/404' || this.router.url=='/checkout' || this.router.url=='/review-order' || this.router.url=='/kinterdashboard' || this.router.url.indexOf('/southerquote/')>-1 || this.router.url.indexOf('/order-management/')>-1){
          this.isaccesswithlogin='0';
        }
        console.log('this.isaccesswithlogin',this.isaccesswithlogin);
        // else{
        //   this.seoService.setallincex();
        // }
      });
  
    this.subscription = this.loadingService.getMessage().subscribe(message => {
      if (message.text == 'start') {
        // setTimeout(() => {
          this.loading = true;
        //});
      }

      if (message.text == 'stop') {
        this.loading = false;
      }

    });
    
    //this.getcontactusSecondDetails();

    router.events.subscribe(() => {
      if (location.path() != '') {
        this.route = location.path();
      } else {
        this.route = 'Home'
      }
      if (this.route != '/product' && this.route != '/allcategory') {
        Common.removeWithExpiry('brdnode');
        Common.removeWithExpiry('treenode');
      }
    });
  }
  getisaccesswithlogin(){
    this.isaccesswithlogin = this.dataService.Getconfigbykey("isaccesswithlogin");
    if (this.isaccesswithlogin == null || this.isaccesswithlogin == undefined || this.isaccesswithlogin == '') {
      this.isaccesswithlogin = Common.getWithExpiry("isaccesswithlogin");
    }
    if (this.isaccesswithlogin == null || this.isaccesswithlogin == undefined || this.isaccesswithlogin == '') {
      this.dataService.GetConfidForanonymoususersbrowsethesite().subscribe((res: any) => {
        this.isaccesswithlogin = res;
        Common.setWithExpiry("isaccesswithlogin", this.isaccesswithlogin);
      });
    }
  }
  // GetFooterPageConfigurations() {
   
  //   if (this.Allconfigurationlist == null || this.Allconfigurationlist == undefined || this.Allconfigurationlist == '') {
  //     try{
  //     this.Allconfigurationlist =JSON.parse(Common.getWithExpiry("GetFooterPageConfigurations"));
  //     }catch(ed){}
  //   }
  //   if (this.Allconfigurationlist == null || this.Allconfigurationlist == undefined || this.Allconfigurationlist == '') {
  //     this.dataService.GetFooterPageConfigurations().subscribe((data: any) => {
  //       this.Allconfigurationlist = data;
  //       Common.setWithExpiry("GetFooterPageConfigurations",JSON.stringify(this.Allconfigurationlist));
  //       for(var i=0;i<this.Allconfigurationlist.length;i++){          
  //         if(this.Allconfigurationlist[i].ConfigKey=="websitetype"){            
  //           Common.setWithExpiry("websitetype", this.Allconfigurationlist[i].ConfigValue);
  //         }
  //         if(this.Allconfigurationlist[i].ConfigKey=="businesstype"){            
  //           Common.setWithExpiry("businesstype", this.Allconfigurationlist[i].ConfigValue);         
  //         }
  //         if(this.Allconfigurationlist[i].ConfigKey=="TreeNode"){            
  //           Common.setWithExpiry("TreeNode", this.Allconfigurationlist[i].ConfigValue);                     
  //         }
  //         if(this.Allconfigurationlist[i].ConfigKey=="decimalpoints"){            
  //           Common.setWithExpiry("decimalpoints", this.Allconfigurationlist[i].ConfigValue);                     
  //         }
  //       }
  //     })
  //   }
  //   else{
  //     for(var i=0;i<this.Allconfigurationlist.length;i++){          
  //       if(this.Allconfigurationlist[i].ConfigKey=="websitetype"){            
  //         Common.setWithExpiry("websitetype", this.Allconfigurationlist[i].ConfigValue);
  //       }
  //       if(this.Allconfigurationlist[i].ConfigKey=="businesstype"){            
  //         Common.setWithExpiry("businesstype", this.Allconfigurationlist[i].ConfigValue);         
  //       }
  //       if(this.Allconfigurationlist[i].ConfigKey=="TreeNode"){            
  //         Common.setWithExpiry("TreeNode", this.Allconfigurationlist[i].ConfigValue);                     
  //       }
  //       if(this.Allconfigurationlist[i].ConfigKey=="decimalpoints"){            
  //         Common.setWithExpiry("decimalpoints", this.Allconfigurationlist[i].ConfigValue);                     
  //       }
  //     }
  //   }
  // }
  
  getcontactusSecondDetails() {
    try {
      if (Common.getWithExpiry("Secondcontact") != undefined) {
        var Secondcontact = JSON.parse(Common.getWithExpiry("Secondcontact"));
      }
    } catch (ed) { }
    if (Secondcontact == null || Secondcontact == undefined || Secondcontact.length == 0) {
      this.contactService.getContactSecondaryDetails().subscribe((res: any) => {
        this.Secondcontact = res;
        this.getContactDtl();
        Common.setWithExpiry("Secondcontact", JSON.stringify(this.Secondcontact));
      });
    }
    else {
      this.Secondcontact = Secondcontact;
      this.getContactDtl();
    }
  }
  getContactDtl() {
    try {
      if (Common.getWithExpiry("contactDtl") != undefined) {
        var contactDtl = JSON.parse(Common.getWithExpiry("contactDtl"));
      }
    } catch (ed) { }
    if (contactDtl == null || contactDtl == undefined || contactDtl == '') {
      this.contactService.getContact(null).subscribe((res: any) => {
        this.contactDtl = res;
        Common.setWithExpiry("contactDtl", this.contactDtl);
        if (this.Secondcontact.cName == undefined || this.Secondcontact.cName == null || this.Secondcontact.cName == '') {
          Common.setWithExpiry("cpname", this.contactDtl.name);
        }
        else {
          Common.setWithExpiry("cpname", this.Secondcontact.cName);
        }
        Common.setWithExpiry("company_cu", this.contactDtl.company_cu);
        Common.setWithExpiry("company_it", this.contactDtl.company_it);
        Common.setWithExpiry("company_sy", this.contactDtl.company_sy);

      })
    }
    else {
      this.contactDtl = contactDtl;
      if (this.Secondcontact.cName == undefined || this.Secondcontact.cName == null || this.Secondcontact.cName == '') {
        Common.setWithExpiry("cpname", this.contactDtl.name);
      }
      else {
        Common.setWithExpiry("cpname", this.Secondcontact.cName);
      }
      Common.setWithExpiry("company_cu", this.contactDtl.company_cu);
      Common.setWithExpiry("company_it", this.contactDtl.company_it);
      Common.setWithExpiry("company_sy", this.contactDtl.company_sy);
    }
  }
  // changeOfRoutes() {
  //   if (this.router.url != "/productdetail") {
  //     // $(".dataTables_scrollBody").hide();
  //     // $(".dataTables_wrapper.DTS").hide();
  //     // $(".dataTables_wrapper").hide();
  //     // $("#lightbox").hide();
  //   }
  // }
  ngOnInit() {
    // Load color configurations based on customer
    this.loadColorConfigurations();
  }

  loadColorConfigurations() {
    const customerId = environment.customerId;
    
    // Customer-specific logic:
    // 1. 'electerm' - uses hard-coded #003454 (dark navy) via CSS [data-customer="electerm"]
    // 2. 'techrim' - uses hard-coded #005faa (blue) via CSS [data-customer="techrim"]
    // 3. Empty '' or other values - uses CSS variable (dynamic) that can be overridden
    
    if (!customerId || customerId === '') {
      // Empty customerId - set dynamic CSS variables for all color properties
      // These can be customized per deployment by updating these values
      document.documentElement.style.setProperty('--pheadingscolor', '#005faa');
      document.documentElement.style.setProperty('--menucolor', '#ffffff');
      document.documentElement.style.setProperty('--menufontcolor', '#333333');
      document.documentElement.style.setProperty('--headercolor', '#f3f3f3');
      document.documentElement.style.setProperty('--footercolor', '#005faa');
      
      console.log('Color configuration: Using dynamic CSS variables (empty customerId)');
    } else if (customerId !== 'electerm' && customerId !== 'techrim') {
      // Other customers (not electerm or techrim) - also use dynamic CSS variables
      document.documentElement.style.setProperty('--pheadingscolor', '#005faa');
      document.documentElement.style.setProperty('--menucolor', '#ffffff');
      document.documentElement.style.setProperty('--menufontcolor', '#333333');
      document.documentElement.style.setProperty('--headercolor', '#f3f3f3');
      document.documentElement.style.setProperty('--footercolor', '#005faa');
      
      console.log('Color configuration: Using dynamic CSS variables for customer: ' + customerId);
    } else {
      // Electerm or Techrim - CSS handles these via [data-customer] attribute
      console.log('Color configuration: Using customer-specific CSS for: ' + customerId);
    }
  }

  // onURLChange(url) {

  //   this.dataService.getRemoteData(url).subscribe((data: any) => {
  //     this.originalData = data
  //     this.mainFilter = {
  //       search: '',
  //       categories: this.originalData.categories.slice(0),
  //       customFilter: this.customFilters[0],
  //       priceFilter: this.priceFilters[0]
  //     }

  //     //Make a deep copy of the original data to keep it immutable
  //     this.products = this.originalData.products.slice(0)
  //     this.sortProducts('itemname')
  //     this.filtersComponent.reset(this.customFilters, this.priceFilters)
  //     this.searchComponent.reset()
  //     //this.cartService.flushCart()
  //   })
  // }

  // onSearchChange(search) {
  //   this.mainFilter.search = search.search
  //   this.updateProducts({
  //     type: 'search',
  //     change: search.change
  //   })
  // }

  // onFilterChange(data) {
  //   if (data.type == 'category') {
  //     if (data.isChecked) {
  //       this.mainFilter.categories.push(data.filter)
  //     } else {
  //       this.mainFilter.categories = this.mainFilter.categories.filter(category => { return category.categori_id != data.filter.categori_id })
  //     }
  //   } else if (data.type == 'custom') {
  //     this.mainFilter.customFilter = data.filter
  //   } else if (data.type == 'price') {
  //     this.mainFilter.priceFilter = data.filter
  //   }
  //   this.updateProducts({
  //     type: data.type,
  //     change: data.change
  //   })
  // }

  // updateProducts(filter) {
  //   let productsSource = this.originalData.products
  //   let prevProducts = this.products
  //   let filterAllData = true
  //   if ((filter.type == 'search' && filter.change == 1) || (filter.type == 'category' && filter.change == -1)) {
  //     productsSource = this.products
  //     filterAllData = false
  //   }
  //   this.products = productsSource.filter(product => {
  //     //Filter by search
  //     if (filterAllData || filter.type == 'search') {
  //       if (!product.itemname.match(new RegExp(this.mainFilter.search, 'i'))) {
  //         return false;
  //       }
  //     }

  //     //Filter by categories
  //     if (filterAllData || filter.type == 'category') {
  //       let passCategoryFilter = false
  //       product.categories.forEach(product_category => {
  //         if (!passCategoryFilter) {
  //           passCategoryFilter = this.mainFilter.categories.reduce((found, category) => {
  //             return found || product_category == category.categori_id
  //           }, false)
  //         }
  //       })
  //       if (!passCategoryFilter) {
  //         return false
  //       }
  //     }

  //     //Filter by custom filters
  //     if (filterAllData || filter.type == 'custom') {
  //       let passCustomFilter = false
  //       let customFilter = this.mainFilter.customFilter.value
  //       if (customFilter == 'all') {
  //         passCustomFilter = true;
  //       } else if (customFilter == 'available' && product.available) {
  //         passCustomFilter = true;
  //       } else if (customFilter == 'unavailable' && !product.available) {
  //         passCustomFilter = true;
  //       } else if (customFilter == 'bestseller' && product.best_seller) {
  //         passCustomFilter = true;
  //       }
  //       if (!passCustomFilter) {
  //         return false
  //       }
  //     }

  //     //Filter by price filters
  //     if (filterAllData || filter.type == 'price') {
  //       let passPriceFilter = false
  //       let customFilter = this.mainFilter.priceFilter.value
  //       let productPrice = parseFloat(product.list_price.replace(/\./g, '').replace(',', '.'))
  //       if (customFilter == 'all') {
  //         passPriceFilter = true;
  //       } else if (customFilter == 'more_30000' && productPrice > 30000) {
  //         passPriceFilter = true;
  //       } else if (customFilter == 'less_10000' && productPrice < 10000) {
  //         passPriceFilter = true;
  //       }
  //       if (!passPriceFilter) {
  //         return false
  //       }
  //     }

  //     return true
  //   })

  //   //If the number of products increased after the filter has been applied then sort again
  //   //If the number of products remained equal, there's a high chance that the items have been reordered.
  //   if (prevProducts.length <= this.products.length && this.products.length > 1) {
  //     this.sortProducts(this.currentSorting)
  //   }

  //   //These two types of filters usually add new data to the products showcase so a sort is necessary
  //   if (filter.type == 'custom' || filter.type == 'price') {
  //     this.sortProducts(this.currentSorting)
  //   }
  // }

  // sortProducts(criteria) {
  //   this.products.sort((a, b) => {
  //     let priceComparison = a.list_price - b.list_price
  //     if (criteria == 'priceDes') {
  //       return -priceComparison
  //     } else if (criteria == 'priceAsc') {
  //       return priceComparison
  //     } else if (criteria == 'name') {
  //       let nameA = a.itemname.toLowerCase(), nameB = b.itemname.toLowerCase()
  //       if (nameA < nameB)
  //         return -1;
  //       if (nameA > nameB)
  //         return 1;
  //       return 0;
  //     } else {
  //       //Keep the same order in case of any unexpected sort criteria
  //       return -1
  //     }
  //   })
  //   this.currentSorting = criteria
  // }
}
